<script lang="ts" setup>
import { ref } from 'vue';
import config from '@/config.json';

const version = ref(config.version);
</script>


<template>
  <footer>
    <div class="row">
      <div class="column">
        <p>
          <small>
            <a href="https://digital-vereint.de">digital verein(t)</a>
            <span class="divider" aria-hidden="true"></span>
            <a href="https://digital-vereint.de/impressum/" target="_blank">Impressum</a>
            <span class="divider" aria-hidden="true"></span>
            <a href="https://digital-vereint.de/datenschutzerklaerung/" target="_blank">Datenschutz</a>
            <span class="divider" aria-hidden="true"></span>
            v&nbsp;{{ version }}
          </small>
        </p>
      </div>
    </div>
  </footer>
</template>


<style lang="scss" scoped>
@import '@/assets/scss/typography.scss';

footer {
  text-align: center;
  color: #aaa;

  .row {
    &:nth-child(odd) {
      background: $color-light;
    }
  }

  p {
    font-size: $font-size-small;
  }

  .divider::before {
    content: "|";
    display: inline-block;
    padding: 0 0.375rem;
  }
}
</style>